import axios from 'axios';
const api = axios.create({
    baseURL: 'https://evajospin.fr/admin/',
});
export default api;
